import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef, useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { primary } from './LinearProgress.tokens.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var _excluded = ["variant", "value"];
var indeterminate = keyframes(["0%{left:-200%;right:100%;}60%{left:107%;right:-8%;}100%{left:107%;right:-8%;}"]);
var Track = styled.div.withConfig({
  displayName: "LinearProgress__Track",
  componentId: "sc-5orxpi-0"
})(["position:relative;overflow:hidden;height:4px;background-color:", ";width:100%;border-radius:50px;"], primary.background);
var ProgressBar = styled.div.withConfig({
  displayName: "LinearProgress__ProgressBar",
  componentId: "sc-5orxpi-1"
})(["transition:transform 0.4s linear;background-color:", ";width:100%;border-radius:50px;position:absolute;left:0;bottom:0;top:0;transition:transform 0.2s linear;transform-origin:left;"], primary.entities.progress.background);
var IndeterminateProgressBar = styled.div.withConfig({
  displayName: "LinearProgress__IndeterminateProgressBar",
  componentId: "sc-5orxpi-2"
})(["width:75%;border-radius:50px;position:absolute;left:0;bottom:0;top:0;transition:transform 0.2s linear;transform-origin:left;background-color:", ";animation:", " 1.5s cubic-bezier(0.165,0.84,0.44,1) 1s infinite;"], primary.entities.progress.background, indeterminate);
var SrOnlyOutput = styled.output.withConfig({
  displayName: "LinearProgress__SrOnlyOutput",
  componentId: "sc-5orxpi-3"
})(["position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0;"]);
var LinearProgress = /*#__PURE__*/forwardRef(function LinearProgress(_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'indeterminate' : _ref$variant,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    rest = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref
  });
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    srProgress = _useState2[0],
    setSrProgress = _useState2[1];
  var barStyle;
  if (variant === 'determinate') {
    if (value !== undefined) {
      props['aria-valuenow'] = Math.round(value);
      props['aria-valuemin'] = 0;
      props['aria-valuemax'] = 100;
      var transform = value - 100;
      barStyle = "translateX(".concat(transform, "%)");
    }
  }
  var transformStyle = {
    transform: barStyle
  };
  useEffect(function () {
    if (variant === 'indeterminate') return;
    if (value >= 25 && value < 50) {
      setSrProgress(25);
    } else if (value >= 50 && value < 75) {
      setSrProgress(50);
    } else if (value >= 75 && value < 100) {
      setSrProgress(75);
    } else if (value === 100) {
      setSrProgress(100);
    }
  }, [value, variant]);
  var getProgressFormatted = function getProgressFormatted() {
    return "Loading ".concat(srProgress, "%");
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Track, _objectSpread(_objectSpread({}, props), {}, {
      role: "progressbar",
      children: variant === 'indeterminate' ? /*#__PURE__*/jsx(IndeterminateProgressBar, {}) : /*#__PURE__*/jsx(ProgressBar, {
        style: transformStyle
      })
    })), variant === 'determinate' && /*#__PURE__*/jsx(SrOnlyOutput, {
      children: getProgressFormatted()
    })]
  });
});

export { LinearProgress };
